import { Days, IWeeklySchedulerItem, IWeeklySchedulerRange } from '@captiveaire/weeklyscheduler';

export class DynamicModelWeeklySchedulerItem implements IWeeklySchedulerItem<any> {
    constructor(
        public day: Days,
        public schedules: Array<IWeeklySchedulerRange<any>>
    ) {
    }

    get editable() {
        return true;
    }
}
